import { render, staticRenderFns } from "./TrialRegistration.vue?vue&type=template&id=0a4f451e&scoped=true&"
import script from "./TrialRegistration.vue?vue&type=script&lang=js&"
export * from "./TrialRegistration.vue?vue&type=script&lang=js&"
import style0 from "./TrialRegistration.vue?vue&type=style&index=0&id=0a4f451e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f451e",
  null
  
)

export default component.exports